import { render } from "./Card.md?vue&type=template&id=7042f413"
const script = {}
script.render = render

export default script